import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import { SharedService } from '../../services/SharedService.service';

@Component({
    selector: 'app-item-branches',
    templateUrl: './item-branches.component.html',
    styleUrls: ['./item-branches.component.scss'],
    providers: []
})
export class ItemBranchesComponent implements OnInit {

    @Input() item;
    @Input() screenName;
    modalRef: NgbModalRef;


    constructor(public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private sharedservice: SharedService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
    }

    ngOnInit() {

    }


    close() {
        this.activeModal.dismiss('done');
    }

}



// WEBPACK FOOTER //
// ./src/app/components/item-branches/item-branches.component.ts